<app-iota-modal [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-header class="flex flex-row">
        <h5 class="mb-0" i18n>Update translations for&nbsp;</h5>
        <h5 class="mb-0">{{ data.title }}</h5>
    </div>

    <div modal-body>
        <div [formGroup]="form">
            <ng-container formArrayName="translationsForm">
                <ng-container *ngFor="let translation of translationsForm.controls; let idx = index; last as isLast">
                    <div class="flex flex-row gap-8 items-end" [formGroup]="translation">
                        <div class="form-control w-full" [ngClass]="{ 'max-w-xl': !isFullScreen }">
                            <label class="label">
                                <span class="label-text" i18n>Translation</span>
                            </label>
                            <input
                                type="text"
                                formControlName="text"
                                class="input input-bordered w-full"
                                [ngClass]="{ 'max-w-xl': !isFullScreen }"
                            />
                        </div>
                        <div class="form-control w-fit max-w-xs">
                            <label class="label">
                                <span class="label-text" i18n>Language</span>
                            </label>
                            <select class="select max-w-xs select-bordered" formControlName="locale">
                                <option
                                    *ngFor="let localeOption of remainingLocalesForIndex[idx]"
                                    [value]="localeOption"
                                    [selected]="localeOption === translationsForm.value[idx].locale"
                                >
                                    {{ localeOption }}
                                </option>
                            </select>
                        </div>
                        <div class="grid grid-cols-2 gap-4 min-w-fit">
                            <button
                                class="btn btn-circle btn-error"
                                (click)="deleteRow(idx)"
                                [disabled]="!!data.required && translationsForm.length === 1"
                            >
                                <iota-icon icon="trash"></iota-icon>
                            </button>
                            <button
                                class="btn btn-circle btn-primary"
                                *ngIf="isLast"
                                [disabled]="remainingLocales.length === 0"
                                (click)="addRow()"
                            >
                                <iota-icon icon="plus"></iota-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <div modal-footer class="flex flex-row justify-between items-center gap-2">
        <button class="btn btn-primary" (click)="onUpdateClick()" [ngClass]="{ loading: loading }" [disabled]="!form.valid" i18n>
            Update
        </button>
        <button class="btn btn-error" (click)="onCancelClick()" i18n>Cancel</button>
    </div>
</app-iota-modal>
